import { Plus, Minus, Maximize2 } from 'lucide-react';

interface ZoomControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  minZoom?: number;
  maxZoom?: number;
}

const ZoomControls = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onReset,
  minZoom = 1,
  maxZoom = 8,
}: ZoomControlsProps) => {
  const canZoomIn = zoom < maxZoom;
  const canZoomOut = zoom > minZoom;
  const isDefault = zoom === minZoom;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000]">
      <div className="glass rounded-lg shadow-glass p-1 flex items-center gap-1">
        {/* Zoom Out */}
        <button
          onClick={onZoomOut}
          disabled={!canZoomOut}
          className="w-8 h-8 flex items-center justify-center rounded-md text-text-secondary
                     hover:text-text-primary hover:bg-white/10 disabled:opacity-30
                     disabled:cursor-not-allowed transition-all duration-150"
          title="Zoom out (-)"
        >
          <Minus className="h-4 w-4" />
        </button>

        {/* Zoom Level Indicator */}
        <div className="w-12 text-center">
          <span className="text-xs font-medium text-text-secondary">
            {zoom.toFixed(1)}x
          </span>
        </div>

        {/* Zoom In */}
        <button
          onClick={onZoomIn}
          disabled={!canZoomIn}
          className="w-8 h-8 flex items-center justify-center rounded-md text-text-secondary
                     hover:text-text-primary hover:bg-white/10 disabled:opacity-30
                     disabled:cursor-not-allowed transition-all duration-150"
          title="Zoom in (+)"
        >
          <Plus className="h-4 w-4" />
        </button>

        {/* Divider */}
        <div className="w-px h-5 bg-white/10 mx-1" />

        {/* Reset */}
        <button
          onClick={onReset}
          disabled={isDefault}
          className="w-8 h-8 flex items-center justify-center rounded-md text-text-secondary
                     hover:text-text-primary hover:bg-white/10 disabled:opacity-30
                     disabled:cursor-not-allowed transition-all duration-150"
          title="Reset zoom (0)"
        >
          <Maximize2 className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ZoomControls;
